<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="18" class="app-main-header-btns">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
				<!-- <el-button size="small" type="success" icon="el-icon-download">导出</el-button> -->
			</el-col>
		</el-row>
		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
								prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<treeselect size="mini" style="width: 200px;" class="my-treeselect"
								v-model="quertInfo.objMap.deptId" :show-count="true" :options="optionDepts"
								placeholder="选择部门" />
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
								start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
								style="width: 240px" v-model="quertInfo.searchTime">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" icon="el-icon-search" @click="onSearch"
								v-hasPermi="['system:user:query']">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle"
					:height="tableHeight()">
					<el-table-column prop="username" label="账号"></el-table-column>
					<el-table-column prop="deptName" label="部门"></el-table-column>
					<el-table-column prop="nickname" label="昵称"></el-table-column>
					<el-table-column prop="qyName" label="企业名称" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="phone" label="电话"></el-table-column>
					<el-table-column prop="sex" label="性别" width="100" :formatter="formatAge"></el-table-column>
					<el-table-column prop="isAuditUser" label="是否评审" width="100"></el-table-column>
					<el-table-column prop="age" label="年龄" width="100"></el-table-column>
					<el-table-column prop="createTime" label="日期" width="200"></el-table-column>
					<el-table-column label="操作" width="240">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)"
								v-hasPermi="['system:user:edit']">
								修改
							</el-button>
							<el-button type="text" icon="el-icon-key" size="mini" v-if="scope.row.id !=1 "
								@click="handleResetPwd(scope.row)">重置密码
							</el-button>
							<el-button type="text" icon="el-icon-delete" size="mini" v-if="scope.row.id !=1 "
								@click="handleDel(scope.row.id)" v-hasPermi="['system:user:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
						:limit.sync="quertInfo.limit" :total="count">
					</pagination>
				</el-row>
			</el-card>
		</el-row>
		<el-dialog :visible.sync="openDialog" width="600px" @closed="addClosed" :title="title" :close-on-click-modal="false">
			<el-form label-width="80px" ref="form" :model="form" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="账号" prop="username">
							<el-input v-model="form.username" placeholder="请输入账号" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="部门">
							<treeselect v-model="form.deptId" :show-count="true" :options="optionDepts"
								placeholder="选择部门" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="昵称" prop="nickname">
							<el-input v-model="form.nickname" placeholder="请输入昵称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="密码" v-if="form.id == undefined" prop="password">
							<el-input v-model="form.password" placeholder="请输入密码" type="password" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电话" prop="phone">
							<el-input v-model="form.phone" placeholder="请输入电话" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="form.email" placeholder="请输入邮箱" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="年龄" prop="age">
							<el-input-number v-model="form.age" controls-position="right" :min="1" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="角色" prop="roleIds">
							<!-- 禁止一个人多种角色，此处避免一个用户即时采购员角色又是供应商角色的情况 -->
							<!-- <el-select v-model="form.roleIds" :disabled="userId==1" multiple placeholder="请选择角色"> -->
							<!-- 供应商注册进来的用户不能自己切换角色 -->
							<!-- 后台管理员用户注册进来的用户不能设置为gys_role：供应商角色和gysWaitAudit 供应商待审核角色 -->
							<el-select v-model="form.roleIds" :disabled="userId==1 || form.userType==0" placeholder="请选择角色" clearable  style="width:100%">
								<el-option v-for="item in optionRoles" :key="item.id" :label="item.name"
									:disabled="(form.userType && form.userType == 1 && (item.code=='gys_role' || item.code=='gysWaitAudit')) || (!form.userType && (item.code=='gys_role' || item.code=='gysWaitAudit'))"
									:value="item.id">
									</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					 <el-col :span="12">
						<el-form-item label="是否评审" prop="isAuditUser">
							<el-radio-group v-model="form.isAuditUser" :disabled="edutRoleKey != 'cgy_role'">
								<el-radio label="是">是</el-radio>
								<el-radio label="否">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别" prop="sex">
							<el-radio-group v-model="form.sex">
								<el-radio :label="0">男</el-radio>
								<el-radio :label="1">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="openDialog = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// 备份：此文件为支持一个用户只能绑定一个角色
	import {
		userList,
		addUser,
		editUser,
		delUser,
		addUserRole,
		userRoleByUserId,
		resetPwd
	} from '@/api/system/user.js'
	import {
		deptTreeSelect,
	} from '@/api/system/dept.js'
	import {
		listRole,
	} from '@/api/system/role.js'
	import Treeselect from '@riophae/vue-treeselect'
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	export default {
		name: "User",
		computed: {},
		components: {
			Treeselect
		},
		data() {
			return {
				title: "",
				tableData: [],
				form: {
					id: undefined,
					username: undefined,
					nickname: undefined,
					qyName: undefined,
					password: undefined,
					email: undefined,
					phone: undefined,
					pointId: undefined,
					status: 0,
					sf: '员工',
					sex: 0,
					isAuditUser:'否',
					roleIds: undefined,
				},
				edutRoleKey:'',
				openDialog: false,
				optionDepts: [],
				optionRoles: [],
				userId: undefined,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: ''
					},
				},
				rules: {
					username: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					phone: [{
							required: true,
							message: "手机号码不能为空",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号码",
							trigger: "blur"
						}
					],
					roleIds:[{
						required: true,
						message: '请选择一个角色',
						trigger: 'blur'
					}]
				},
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				firstInit:false,
			};
		},
		created() {
			this.getList();
			this.getDeptTreeSelect();
			this.getRoleList();
		},
		methods: {
			addClosed(){
				console.log('执行关闭')
				this.firstInit = false;
			},
			getRoleList() {
				let _this = this;
				listRole().then(res => {
					if (res.data.code == 0) {
						_this.optionRoles = res.data.data;
					}
				})

			},
			/** 查询菜单下拉树结构 */
			getDeptTreeSelect: async function() {
				let _this = this;
				const {
					data: res
				} = await deptTreeSelect({})
				if (res.code == 0) {
					_this.optionDepts = res.data;

				} else {
					_this.$fail(res.msg);
				}
			},
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList()
			},
			async getList() {
				let _this = this;
				const {
					data: res
				} = await userList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				} else {
					_this.$fail(res.msg);
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					username: undefined,
					nickname: undefined,
					qyName: undefined,
					password: undefined,
					email: undefined,
					phone: undefined,
					pointId: undefined,
					status: 0,
					sf: '员工',
					sex: 0,
					isAuditUser:'否',
					roleIds: undefined,
				};
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						console.log(_this.form)
						let pramar = {..._this.form};
						pramar['roleIds'] = [_this.form.roleIds];
						if (pramar.id != undefined) {
							editUser(pramar).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
							pramar['userType'] = 1;
							addUser(pramar).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增用户";
				this.openDialog = true;
			},
			handleEdit: async function(row) {
				let _this = this;
				_this.reset();
				const {
					data: res
				} = await userRoleByUserId({
					userId: row.id
				});
				_this.userId = row.id;
				if (res.code == 0) {
					let roleData = res.data || [];
					// let roleIds = new Array();
					// roleData.forEach(item => {
					// 	roleIds.push(item.roleId);
					// })
					row.roleIds = roleData[0]?.roleId;
				}
				_this.title = "修改用户";
				_this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.$nextTick(()=>{
					this.firstInit = true;
				})
				_this.openDialog = true;
			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delUser(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.open = false;
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			formatAge: function(row) {
				return row.sex == 0 ? '男 ' : '女';
			},
			handleResetPwd: function(row) {
				let _this = this;
				_this.$prompt('请输入密码', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^(\w){6,20}$/,
					inputErrorMessage: '只能输入6-20个字母、数字、下划线'
				}).then(({
					value
				}) => {
					const param = {
						id: row.id,
						username: row.username,
						password: value
					}
					resetPwd(param).then(({
						data
					}) => {
						if (data.code == 0) {
							_this.$success(data.msg)
						} else {
							_this.$fail(data.msg)
						}
					})
				}).catch(() => {});
			}
		},
		watch:{
			// 处理逻辑 ： 只能是采购员角色 才能是评委
			'form.roleIds':function(val) {
				let _this = this;
				if(val){
					_this.optionRoles.forEach((item)=>{
						if(item.id == val){
							if(item.code == 'leader_c' || item.code == 'leader_b' || item.code == 'leader_a'){
								_this.edutRoleKey = 'leader'
							}else{
								_this.edutRoleKey = item.code
							}
						}
						if(_this.edutRoleKey != 'cgy_role' && this.firstInit){
							_this.form.isAuditUser = '否'
						}
					})
				}else{
					_this.edutRoleKey = ''
				}
			}
		}
	};
</script>
<style scoped="scoped" lang="scss">
	::v-deep .my-treeselect {
		line-height: 28px;
		margin-top: 2px;

		.vue-treeselect__placeholder {
			line-height: 28px;
		}

		.vue-treeselect__control {
			height: 28px;
		}
	}
</style>
